import type { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import {
  BasicCard,
  LoadingCard,
  PromotedCard,
  UnpromotedCard,
} from './components';
import { VisuallyHidden } from './components/sub-components';
import * as Styled from './product-cards.styled';
import type { ProductCardsProps } from './product-cards.types';

export type { ProductCardsProps } from './product-cards.types';

export const ProductCards = ({
  activationUrls,
  data,
  loading,
  onActivate,
  onDiscover,
  onFeatureDiscovery,
  perks,
  productCardsGroupRef,
}: ProductCardsProps): ReactElement => {
  const { formatMessage } = useIntl();
  const unpromoted = data?.unpromoted;

  return (
    <>
      <VisuallyHidden role="status">
        {formatMessage({
          id: loading
            ? 'UPSELL_MEMBERSHIPS_PRODUCT_CARDS_LOADING'
            : 'UPSELL_MEMBERSHIPS_PRODUCT_CARDS_LOADED',
        })}
      </VisuallyHidden>
      <Styled.ProductCardContainer
        ref={productCardsGroupRef}
        aria-busy={loading}
        data-qa="product-cards"
      >
        {loading ? (
          <>
            <LoadingCard />
            <LoadingCard />
            <LoadingCard />
          </>
        ) : data ? (
          <>
            <BasicCard {...data.basic} />
            <PromotedCard
              {...data.promoted}
              activationUrl={activationUrls[data.promoted.product]}
              detailsUrl="#"
              onActivate={() => onActivate?.(data.promoted.product)}
              onDiscover={() => onDiscover(data.promoted.product)}
              onFeatureDiscovery={() =>
                onFeatureDiscovery?.(data.promoted.product)
              }
              perks={perks?.[data.promoted.product]}
            />
            {unpromoted ? (
              <UnpromotedCard
                {...unpromoted}
                activationUrl={activationUrls[unpromoted.product]}
                detailsUrl="#"
                onActivate={() => onActivate?.(unpromoted.product)}
                onDiscover={() => onDiscover(unpromoted.product)}
                onFeatureDiscovery={() =>
                  onFeatureDiscovery?.(unpromoted.product)
                }
                perks={perks?.[unpromoted.product]}
              />
            ) : null}
          </>
        ) : null}
      </Styled.ProductCardContainer>
    </>
  );
};
